
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["w-7",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","class":"w-7","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.021 6.282c1.855 0 3.36-1.406 3.36-3.141S12.875 0 11.02 0 7.662 1.406 7.662 3.14c0 1.736 1.504 3.142 3.36 3.142z","fill":"#F0A53D"}}),_c('path',{attrs:{"d":"M4.08 6.281c1.204 0 2.18-.912 2.18-2.037 0-1.126-.976-2.038-2.18-2.038-1.203 0-2.179.912-2.179 2.038 0 1.125.976 2.037 2.18 2.037zm13.825 0c1.204 0 2.18-.912 2.18-2.037 0-1.126-.976-2.038-2.18-2.038-1.203 0-2.179.912-2.179 2.038 0 1.125.976 2.037 2.18 2.037zm.011 1.433c-.93 0-1.777.295-2.472.78 1.167 1.063 1.89 2.547 1.89 4.171v2.738h3.18c.82 0 1.486-.614 1.486-1.369v-2.546c.014-2.085-1.82-3.774-4.084-3.774zm-13.36 5.233c0-1.753.777-3.326 2-4.452a4.305 4.305 0 00-2.459-.78C1.833 7.714 0 9.402 0 11.487v2.572c0 .755.667 1.369 1.486 1.369h3.056v-2.481h.014z","fill":"#EAD4AA"}}),_c('path',{attrs:{"d":"M16.5 16.393c0 .886-.694 1.607-1.547 1.607H7.047c-.853 0-1.547-.72-1.547-1.607v-2.642c0-3.094 2.226-5.871 5.204-6.022.1 0 .296-.015.289-.015 3.035 0 5.492 2.553 5.492 5.706l.015 2.652v.321z","fill":"#F0A53D"}})])
          )
        }
      }
    